import React from 'react';

export interface QuoteStepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  labels: string[];
}

export const QuoteStepIndicator: React.FC<QuoteStepIndicatorProps> = ({
  currentStep,
  totalSteps,
  labels,
}) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-brand-300">
          {currentStep} / {totalSteps}
        </span>
        <span className="text-xs text-slate-400">{labels[currentStep - 1]}</span>
      </div>
      <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${totalSteps}, minmax(0, 1fr))` }}>
        {Array.from({ length: totalSteps }, (_, index) => {
          const step = index + 1;
          return (
            <div
              key={step}
              className="h-1.5 overflow-hidden rounded-full bg-slate-700/80"
              aria-hidden="true"
            >
              <div
                className="h-full rounded-full bg-brand-500 transition-[width] duration-500 ease-out"
                style={{ width: step <= currentStep ? '100%' : '0%' }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
